// ═══════════════════════════════════════
// DRONE — Bourdons Web Audio API
// ═══════════════════════════════════════

import { DRONE_FREQS_HP, DRONE_FREQS_CMIN } from './config.js';
import { onInstrumentsChange,hasInstrument } from './instrument-context.js';


let droneCtx = null;
let droneNodes = [];
let droneMasterGain = null;
let dronesActive = false;

export function isDronesActive() { return dronesActive; }

function initDroneContext() {
    if (droneCtx) return;
    droneCtx = new (window.AudioContext || window.webkitAudioContext)();
    droneMasterGain = droneCtx.createGain();
    droneMasterGain.gain.value = 0.016;
    droneMasterGain.connect(droneCtx.destination);
}

export function startDrones(freqs = DRONE_FREQS_HP) {
    initDroneContext();
    if (droneCtx.state === 'suspended') droneCtx.resume();
    stopDrones(false);
    freqs.forEach((freq, i) => {
        const osc    = droneCtx.createOscillator();
        const gain   = droneCtx.createGain();
        const filter = droneCtx.createBiquadFilter();
        filter.type = 'lowpass';
        filter.frequency.value = 900;
        osc.type = 'sawtooth';
        osc.frequency.value = freq;
        osc.detune.value = 0;
        gain.gain.value = i === 0 ? 1.2 : 0.9;
        osc.connect(filter);
        filter.connect(gain);
        gain.connect(droneMasterGain);
        osc.start();
        droneNodes.push({ osc, gain, filter });
    });
    dronesActive = true;
}

export function stopDrones(updateFlag = true) {
    droneNodes.forEach(node => {
        try { node.osc.stop(); } catch(e) {}
        node.osc.disconnect();
        node.filter.disconnect();
        node.gain.disconnect();
    });
    droneNodes = [];
    if (updateFlag) dronesActive = false;
}

export function setDroneVolume(val) {
    if (droneMasterGain) droneMasterGain.gain.value = val / 500;
}

// Réaction aux changements d'instruments
onInstrumentsChange(() => {
    const label = document.getElementById('drone-label');
    if (!label) return;
    const hasBagpipe = hasInstrument('bagpipe');
    label.style.display = hasBagpipe ? '' : 'none';
    if (!hasBagpipe) {
        const checkbox = document.getElementById('drone-checkbox');
        if (checkbox) checkbox.checked = false;
        stopDrones();
    }
});